module.exports = __webpack_public_path__ + "brandLogo.d31f497cc37744b90a2954e5b0aff555.svg";